module.exports = __webpack_public_path__ + "static/media/initial.4d45c657.jpg";